/** @jsx jsx */ import { jsx } from '@emotion/core'
import * as React from 'react'
import StyledComponent, { GetStylesType } from './StyledComponent'
import {
  PlayPauseButton as PPBtn,
  SkipButton as SBtn,
  Buttons as Btns,
} from '../Styles/index'
import SkipButton from './SkipButton'
import PlayPauseButton from './PlayPauseButton'
import { AudioContext } from '../Context'

const Buttons: React.FC<BuutonsProps> = ({
  onClickNext,
  onClickPrev,
  hidden = false,
  disabled = false,
  timeout,
  styles,
}) => {
  const { isPaused, play } = React.useContext(AudioContext)

  const disabledStatus = getDisabledStatus(disabled)
  const hiddenStatus = getDisabledStatus(hidden)

  return (
    <StyledComponent>
      {({ getStyles }: { getStyles: GetStylesType }) => (
        <div css={getStyles('buttonsWrapper', {})}>
          {!hiddenStatus.prev && (
            <SkipButton
              styles={styles}
              disabled={disabledStatus.prev}
              onClick={e =>
                onClickPrev ? onClickPrev(e, { play, isPaused }) : () => {}
              }
            />
          )}
          {!hiddenStatus.play && (
            <PlayPauseButton
              styles={styles}
              disabled={disabledStatus.play}
              timeout={timeout}
            />
          )}
          {!hiddenStatus.next && (
            <SkipButton
              styles={styles}
              disabled={disabledStatus.next}
              direction="next"
              onClick={e =>
                onClickNext ? onClickNext(e, { play, isPaused }) : () => {}
              }
            />
          )}
        </div>
      )}
    </StyledComponent>
  )
}

export default Buttons

function checkValue(value: DisabledOrHidden, type: string) {
  return (
    (Array.isArray(value) && value.includes(type)) ||
    (typeof value === 'string' && value === type)
  )
}

function getDisabledStatus(value: DisabledOrHidden) {
  return value === true
    ? {
        play: true,
        prev: true,
        next: true,
      }
    : {
        play: checkValue(value, 'play'),
        prev: checkValue(value, 'prev'),
        next: checkValue(value, 'next'),
      }
}

type BuutonsProps = {
  onClickNext?: ClickProp
  onClickPrev?: ClickProp
  hidden?: DisabledOrHidden
  disabled?: DisabledOrHidden
  timeout?: number
  styles?: PPBtn.StylesObj & SBtn.StylesObj & Btns.StylesObj
}

export type ClickProp = {
  (event: React.MouseEvent<HTMLButtonElement>, player: PlayerProps): void
}

export type DisabledOrHidden = boolean | string[] | 'prev' | 'next' | 'play'

type PlayerProps = {
  play?: () => void
  isPaused?: boolean
}
